import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useConsent } from '../contexts/ConsentContext';

function useIsTabletOrLarger() {
  const [isTablet, setIsTablet] = useState(() => window.innerWidth >= 768);
  useEffect(() => {
    const handler = () => setIsTablet(window.innerWidth >= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isTablet;
}

export default function CookieBanner() {
  const { cookiesAccepted, setCookiesAccepted } = useConsent();
  const [mounted, setMounted] = useState(false);
  const isTablet = useIsTabletOrLarger();
  const { t } = useTranslation();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted || cookiesAccepted !== undefined) return null;

  const cardStyle = {
    borderRadius: '12px',
    background:
      'radial-gradient(72.46% 2094.65% at 8.56% 0%, rgba(244, 235, 255, 0.16) 0%, rgba(235, 235, 255, 0.06) 100%)',
    backdropFilter: 'blur(22px) saturate(1.4)',
    WebkitBackdropFilter: 'blur(22px) saturate(1.4)',
    boxShadow: '0px 0px 20.78px 0px #00000017, 0px 0px 127.88px 0px #0000002E',
    overflow: 'hidden',
  };

  const textNode = (
    <span
      style={{
        fontSize: '12px',
        lineHeight: '140%',
        fontWeight: 400,
        color: '#D9D1DC',
      }}
    >
      {t('cookie_banner_text')}
    </span>
  );

  const acceptBtn = (
    <button
      onClick={() => setCookiesAccepted(true)}
      style={{
        minWidth: '100px',
        height: '32px',
        fontSize: '12px',
        borderRadius: '12px',
        border: 'none',
        background: 'linear-gradient(135deg, #a855f7, #7c3aed)',
        color: '#fff',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        cursor: 'pointer',
        padding: '0 16px',
        whiteSpace: 'nowrap',
      }}
    >
      {t('cookie_accept')}
    </button>
  );

  // ── Desktop layout (position: fixed, bottom-right) ──────────────────────
  if (isTablet) {
    return (
      <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '50px',
          zIndex: 50,
          isolation: 'isolate',
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        <div
          id="accept-cookies-popup"
          style={{
            ...cardStyle,
            borderTop: '1px solid #FFFFFF1F',
            borderRight: '1px solid #FFFFFF1F',
            borderBottom: '1px solid #FFFFFF1F',
            borderLeft: '1px solid #FFFFFF1F',
            padding: '10px',
            maxWidth: '400px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '16px',
              maxHeight: '97px',
            }}
          >
            {textNode}
            {acceptBtn}
          </div>
        </div>
      </div>
    );
  }

  // ── Mobile layout: fixed at the bottom of the viewport, always visible ─────
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        fontFamily: 'Poppins, sans-serif',
        padding: '8px 10px 10px',
      }}
    >
      <div
        id="accept-cookies-popup"
        style={{
          ...cardStyle,
          borderTop: '1px solid #FFFFFF1F',
          borderRight: '1px solid #FFFFFF1F',
          borderLeft: '1px solid #FFFFFF1F',
          borderBottom: '1px solid #FFFFFF1F',
          padding: '5px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
          }}
        >
          <span
            style={{
              fontSize: '9px',
              lineHeight: '140%',
              fontWeight: 400,
              color: '#D9D1DC',
            }}
          >
            {t('cookie_banner_text')}
          </span>
          <button
            onClick={() => setCookiesAccepted(true)}
            style={{
              minWidth: '80px',
              height: '28px',
              fontSize: '12px',
              borderRadius: '12px',
              border: 'none',
              background: 'linear-gradient(135deg, #a855f7, #7c3aed)',
              color: '#fff',
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              cursor: 'pointer',
              padding: '0 12px',
              whiteSpace: 'nowrap',
            }}
          >
            {t('cookie_accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
